import c from "../../../utils/constants";

class BotSessionsFilterController {
  constructor($scope, FilterService, EventsService) {
    "ngInject"

    this.filterService = FilterService;
    this.eventsService = EventsService;
    
    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true)
  }
  
  $onInit() {
    this.setFilterOptions();
    
    this.eventsService.listen(c.events.GLOBAL_FILTER_APPLIED, (e, globalFilter) => {
      console.log("Bot Sessions global filter applied::", globalFilter);
      
      this.setFilterOptions(globalFilter.type);
    })
    
  }

  setFilterOptions(activeGlobalFilter) {
    this.filterOptions = this.filterService.getbotSessionsFilterOptions(activeGlobalFilter);
    return this.filterOptions;
  }

  onFilterChagne(newval, oldval) {
    this.filterService.generateFilterExpression(this.filterOptions);
    this.applyFilters();
  }
  
}

export default BotSessionsFilterController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/bot-sessions-filter/bot-sessions-filter.controller.js
 **/